import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Silent } from "@/__main__/data-model.mjs";
import QueueSymbol from "@/game-lol/utils/symbol-queue.mjs";
import { RankSymbol } from "@/game-lol/utils/symbol-rank.mjs";

const RankObject = {
  queue: QueueSymbol,
  tier: RankSymbol,
  rank: String,
  wins: Number,
  losses: Number,
  leaguePoints: Number,
  insertedAt: Date,
} satisfies ModelDefinition;

export const model = {
  id: Silent(String),
  accountId: String,
  puuid: String,
  summonerId: String,
  summonerName: Silent(String), // Can be empty since Riot ID transition
  summonerLevel: Number,
  profileIconId: Number,
  riotAccount: {
    id: String,
    puuid: String,
    gameName: String,
    tagLine: String,
  },
  updatedAt: Silent(String),
  latestRanks: Silent([RankObject]), // latestRanks should be used for latest ranks in api-regions
  // querying "ranks" will be deprecated in favor of "latestRanks" (it will work for all regions)
  ranks: Silent([RankObject]),
} satisfies ModelDefinition;

const extendedModel = {
  ...model,
  // ==========================================
  // Fields added by us outside of transform.
  derivedId: Silent(String),
  encryptedSummonerId: Silent(String),
  unencryptedSummonerId: Silent(Number),
  // ==========================================
} satisfies ModelDefinition;

const apiModelValidation = createModel({
  data: { leagueProfile: extendedModel },
}).transform(extendedModel, (data) => {
  const profile = data.data.leagueProfile;
  profile.latestRanks = profile.latestRanks || profile.ranks;
  return profile;
});

export type SummonerRank = FromModel<typeof RankObject>;

export default apiModelValidation;
